import React, { useRef } from "react";
import L from "leaflet";
import {
  Marker,
  Polygon,
  Popup,
  FeatureGroup,
  Tooltip as LeafletTooltip,
  Tooltip,
  Polyline,
} from "react-leaflet";

import "react-leaflet-markercluster/dist/styles.min.css";
import "leaflet/dist/leaflet.css";

import "../styles/index.css";
import "../styles/fleetmap.css";

const idle = require("../images/man-standing.gif");
const statusNone = require("../images/marker-gopal.png");
const active = require("../images/person.png");
const inActive = require("../images/runing.gif");
const vehicleImg = require("../images/truckTwo.gif");
const inTransit = require("../images/truckOne.gif");
const noLoad = require("../images/noLoad.png");

const UsersVehiclesPlotting = (props: any) => {
  const {
    zoomControl,
    details,
    tripDelivery,
    trackedUsers,
    childRef,
    showMarker,
    showUser,
    vehicle,
    showVehicles,
    showLabels,
  } = props;
  const tripGroupRef: any = useRef(null);
  if (childRef) {
    childRef.tripGroupRef = tripGroupRef;
  }

  const getMapMarkerIcons = (status) => {
    let iconUrl = statusNone;
    switch (status) {
      case "idle":
        iconUrl = idle;
        break;
      case "active":
        iconUrl = active;
        break;
      case "inactive":
        iconUrl = inActive;
        break;
      case "breakdown":
        iconUrl = vehicleImg;
        break;
      case "intransit":
        iconUrl = inTransit;
        break;
      case "no load":
        iconUrl = noLoad;
        break;
      default:
        iconUrl = statusNone;
    }

    let customMarker = null;
    let width = 100;
    let angle = 0;
    /**
     * info: onZoom icon size management, commented for now
     */
    // if (zoomControl >= 1 && zoomControl <= 4) {
    //   width = 30;
    // } else if (zoomControl > 4 && zoomControl <= 8) {
    //   width = 50;
    // } else if (zoomControl > 8 && zoomControl <= 12) {
    //   width = 70;
    // } else if (zoomControl > 12 && zoomControl <= 16) {
    //   width = 80;
    // }

    const html =
      "<div class='movingMarker' id='movingmarker-" +
      status +
      "' style='transform: rotate(" +
      angle.toString() +
      "deg);'><img src='" +
      iconUrl +
      "' alt='' width='" +
      width +
      "px'/></div>";

    customMarker = L.divIcon({
      html: html,
      iconSize: new L.Point(50, 50),
      iconAnchor: null,
      popupAnchor: [0, -3],
      className: "mapMarker",
    });

    return customMarker;
  };

  return (
    <>
      {/* for users and vehicles filter */}

      {/* users filter */}
      {showUser &&
        showMarker &&
        trackedUsers &&
        trackedUsers.map((user, i) => {
          return (
            <Marker
              position={{
                lat: user.latitude,
                lng: user.longitude,
              }}
              icon={getMapMarkerIcons(user.status)}
              key={"usersOnMap-" + i}
              className="mapMarker"
            >
              <LeafletTooltip
                direction="right"
                offset={[10, -2]}
                className={"makerLabel"}
                permanent
              >
                <span>{user.logtime}</span>
              </LeafletTooltip>
            </Marker>
          );
        })}

      {/* vehicles filter */}
      {showVehicles &&
        showMarker &&
        vehicle.map((vehicle, i) => {
          return (
            <Marker
              position={{
                lat: vehicle.lat,
                lng: vehicle.lng,
              }}
              icon={getMapMarkerIcons(vehicle.status)}
              key={"vehiclesOnMap-" + i}
              className="mapMarker"
            >
              {showLabels && (
                <LeafletTooltip
                  direction="right"
                  offset={[10, -2]}
                  className={"makerLabel"}
                  permanent
                >
                  <span>{vehicle.name}</span>
                </LeafletTooltip>
              )}
            </Marker>
          );
        })}

      {/* trip deliveries  */}
      <FeatureGroup ref={tripGroupRef}>
        {details &&
          tripDelivery.map((polygon, index) => (
            <Polygon
              key={index}
              positions={polygon.vertices}
              color={"purple"}
              className="zone"
            >
              <Popup>
                <div className="markerPopup">
                  <div>
                    <h4>
                      <span className="popupName">{polygon.areaName}</span>
                    </h4>
                    <p className="popupAddress">{polygon.enteredOn}</p>
                    <p className="popupAddress">{polygon.deliveryComments}</p>
                    {/* for showing the image  */}
                    {/* {polygon.files.map((v, i) => {
                    return (
                      <img
                        src={`${API_CONFIG.STATIC_URL}${v.path}`}
                        alt="Image Description"
                        style={{ width: "maxContent", height: "100px" }}
                      />
                    );
                  })} */}
                  </div>
                </div>
              </Popup>
            </Polygon>
          ))}
      </FeatureGroup>
    </>
  );
};

export default UsersVehiclesPlotting;
